import LoginForm from '../../components/Auth/LoginForm';
import Footer from '../../components/Layout/Footer';
import Navbar from '../../components/Layout/Navbar';
import PageMeta from '../../components/pagesHelmet/PageMeta';

export default function LoginPage() {
  return (
    <>
    <PageMeta title="Login | U2LR URL Shortener" description="" / >
        <Navbar />
        <div className="auth-page">
          <LoginForm />
        </div>
      <Footer />
    </>
  );
}